import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import * as constants from '@adc/constants';
import Text from '../../../elementals/text';
import Modal from '../../../overlays/modal';
import { formatMoney } from '../../../../utils/formatters';
import { isREO, getProductType } from './utils';
import ListingBadge, { BADGE_MODE } from './base';
const formatDate = val => moment(val).format('MM/DD/YYYY');
const CURRENT_RENT = 'Current Rent';
const LEASE_START_DATE = 'Lease Start Date';
const LEASE_END_DATE = 'Lease End Date';
const REMAINING_TERM = 'Remaining Term';
const SECURITY_DEPOSIT = 'Security Deposit';
const SECURITY_DEPOSIT_AMOUNT = 'Security Deposit Amount';
const calculateDateDiff = (start, end, periods = ['years', 'months', 'days']) => {
    const parts = [];
    let currentStart = start;
    while (periods.length) {
        const [unit] = periods;
        const amount = end.diff(currentStart, unit);
        if (amount) {
            currentStart = currentStart.add(amount, unit);
            parts.push(`${amount} ${unit}`);
        }
        periods.shift();
    }
    return parts.join(' ');
};
const LEASE_INFO = [
    {
        label: CURRENT_RENT,
        fieldPath: 'current_rent',
        elmId: 'current_rent',
        format: val => (val !== 'N/A' ? formatMoney(val) : val),
    },
    {
        label: LEASE_START_DATE,
        fieldPath: 'lease_start_date',
        elmId: 'lease_start_date',
        format: val => (val !== 'N/A' ? formatDate(val) : ' '),
    },
    {
        label: LEASE_END_DATE,
        fieldPath: 'lease_expiration_date',
        elmId: 'lease_expiration_date',
        format: val => (val !== 'N/A' ? formatDate(val) : ' '),
    },
    {
        label: REMAINING_TERM,
        fieldPath: 'lease_expiration_date',
        elmId: 'remaining_term',
        format: expiration => expiration
            ? calculateDateDiff(moment(), moment(expiration))
            : 'Month-to-Month',
    },
    {
        label: SECURITY_DEPOSIT,
        fieldPath: 'is_security_deposit_charged',
        elmId: 'security_deposit_charged',
        format: val => (val ? 'Yes' : 'No'),
    },
    {
        label: SECURITY_DEPOSIT_AMOUNT,
        fieldPath: 'security_deposit_amount',
        elmId: 'security_deposit_amount',
        format: val => formatMoney(val),
    },
];
const getFieldValue = (property, fieldInfo = {}) => {
    const val = _.get(property, fieldInfo.fieldPath, '');
    return _.isFunction(fieldInfo.format) ? fieldInfo.format(val) : val;
};
export default class RentalBadge extends ListingBadge {
    static title = 'Income Producing';
    static summary = 'Yes';
    static titleIcon = 'hands-usd';
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            getProductType(listing) === constants.graph.enums.ProductType.RENTALS &&
            isREO(listing));
    }
    get content() {
        const { listing } = this.props;
        return (_jsxs(_Fragment, { children: ["This property has a tenant with a lease in place.", ' ', _jsx(Modal, { title: 'Lease Information', size: 'tiny', mobileTitleSkin: 'light', fullScreen: 'mobileOnly', elmId: 'lease_info_modal', trigger: _jsx("a", { "data-elm-id": 'lease_info_trigger', children: "See Lease Information" }), children: _jsx(Modal.Content, { "data-elm-id": 'lease_info_content', children: _jsxs(Text, { children: [_jsxs("div", { children: ["This property has a tenant with a lease in place.", ' ', _jsx("a", { href: '/lp/learn-more/rentals/', "data-elm-id": 'learn_more_rentals_link', target: '_blank', children: "Learn more about Rentals" })] }), _jsx(Table, { basic: 'very', compact: 'very', unstackable: true, children: _jsx(Table.Body, { children: LEASE_INFO.map((fieldInfo, index) => {
                                            const fieldValue = getFieldValue(listing.rental, fieldInfo);
                                            return (Boolean(fieldValue) && (_jsxs(Table.Row, { children: [_jsx(Table.Cell, { children: _jsx(Text, { color: 'gray', weight: 'heavy', "data-elm-id": `${fieldInfo.elmId}_label`, children: fieldInfo.label }) }), _jsx(Table.Cell, { children: _jsx(Text, { color: 'gray', "data-elm-id": `${fieldInfo.elmId}_value`, children: fieldValue }) })] }, index)));
                                        }) }) }), _jsx("div", { children: "For specific lease terms, including the tenant's right to extend the lease, review the lease in the Additional Documents section." })] }) }) })] }));
    }
}
//# sourceMappingURL=rental.js.map